export default from './replaceResultTransformer';
